/* @generated */

// src/assets/pictogram/edit.tsx
import * as React from "react";
var EditPictogram = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 64 64", fill: "none", ...props }, /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M53 49H11v4h42v-4Zm-5.493-26.729a6.999 6.999 0 0 0 0-9.9l-.929-.929a6.999 6.999 0 0 0-9.9 0L16.286 31.836l-2.707 13.535 13.535-2.707 20.393-20.393Zm-3.757-8 .929.929a2.999 2.999 0 0 1 0 4.243l-1.7 1.7-5.179-5.168 1.7-1.7a3.073 3.073 0 0 1 4.25-.004Zm-25.072 26 1.293-6.465 15-15 5.172 5.172-15 15-6.465 1.293Z",
    fill: "currentColor"
  }
));
export {
  EditPictogram
};
